import React from 'react'

export default function HeaderCatalog() {
  return (
    <div className="header-catalog">
        <a href="/catalog" className="">Каталог</a>
    </div>
  )
}
